var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';

class ToggleDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.open
    };
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show() {
    this.setState({ show: true });
  }

  hide() {
    this.setState({ show: false });
    this.props.onHide();
  }

  render() {
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null,
      !this.state.show && /*#__PURE__*/_jsx("button", { onClick: this.show }, void 0, this.props.showLabel),
      this.state.show && /*#__PURE__*/_jsx("button", { onClick: this.hide }, void 0, this.props.hideLabel),
      this.state.show && this.props.children
      ));

  }
}

ToggleDisplay.defaultProps = {
  onHide: () => {},
  showLabel: 'show',
  hideLabel: 'hide',
  open: false
};











export default ToggleDisplay;